import React  from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlock, faLock } from "@fortawesome/free-solid-svg-icons";

import gameService from '../../../services/GameService';


/**
 * The freeze team link class.
 */
class FreezeTeamLink extends React.Component
{
    /**
     * The toggle frozen event handler.
     */
    onToggleFrozen = () =>
    {
        // Freeze the team
        gameService.freezeTeam(this.props.gameId, this.props.teamId, !this.props.frozen);
    }


    /**
     * This method renders the component.
     */
    render()
    {
        return (
            <span class="fa-buttons" onClick={ this.onToggleFrozen }><FontAwesomeIcon icon = { this.props.frozen ? faLock : faUnlock } /></span>
        );
    }
}

export default FreezeTeamLink;